module.exports = __webpack_public_path__ + "img/icon_23years_hk.11c0ceb0.png";